// ThemeToggleButton.tsx
import React, { useState } from 'react';
import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Stack
} from '@mui/material';
import { Brightness4, Brightness7 } from '@mui/icons-material';
import RestoreIcon from '@mui/icons-material/Restore';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import { useTheme } from '@mui/material/styles';
import { ThemeContext } from './ThemeContext.js';
import ColorPickerPanel from './ColorPickerPanel';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux'


const ThemeToggleButton = () => {

  const [editTheme, setEditTheme] = useState(false);
  const theme = useTheme();
  const muiTheme = useSelector((state) => state.theme.value.muiTheme)
  const ctx = React.useContext(ThemeContext);
  if (!ctx) return null;
  const {

    setPrimaryColor,
    setSecondaryColor,
  } = ctx;

  const { toggleColorMode } = ctx;
  const handleEditThemeOpen = () => {
    setEditTheme(true);

  };

  return (
    <>
      <IconButton onClick={toggleColorMode} color="inherit">
        {theme.palette.mode === 'dark' ? <Brightness7 /> : <Brightness4 />}
      </IconButton>
      <IconButton onClick={handleEditThemeOpen} color="inherit">
        <ColorLensIcon />
      </IconButton>
      <Dialog
        open={!!editTheme}
        onClose={() => setEditTheme(false)}
        fullWidth>
        <DialogTitle>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            Edit Theme
            <IconButton
              onClick={() => setEditTheme(false)}
              sx={{}}
              color="inherit">
              <CloseIcon />
            </IconButton>
          </Stack>

        </DialogTitle>
        <DialogContent>
          <ColorPickerPanel />
          <Stack
            sx={{
              alignItems: "center",
              alignContent: "center",

            }}>
            <IconButton
              onClick={() => {
                setPrimaryColor(
                  muiTheme.palette.primary.main
                );
                setSecondaryColor(
                  muiTheme.palette.secondary.main
                )
              }}
              sx={{

              }}
              size="small"
              color="inherit">
              <RestoreIcon />
            </IconButton>
          </Stack>
        </DialogContent>

      </Dialog>
    </>
  );
};

export default ThemeToggleButton;
